import { Component, OnInit } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';

import 'rxjs/add/operator/mergeMap';
import {ACLFeature} from '../../_models/acl-feature';

const log = Log.create('BatchEditBridges');

@Component({
  templateUrl: 'edit.component.html',
  styleUrls: ['edit.less']
})

export class BatchEditBridgesComponent implements OnInit {

  // family: ModuleFamily = new ModuleFamily('test');
  parentId: number;
  path: string;
  bridgeIds: any;
  bridges: any;

  isVisible?: boolean = false;
  isVisibleNa?: boolean = false;
  isVisibleSa?: boolean = false;
  isVisibleCn?: boolean = false;
  isVisibleRoa?: boolean = false;

  isInMaintenanceMode?: boolean = false;
  isInMaintenanceModeNa?: boolean = false;
  isInMaintenanceModeSa?: boolean = false;
  isInMaintenanceModeCn?: boolean = false;
  isInMaintenanceModeRoa?: boolean = false;

  viewStatus?: any;
  viewStatusNa?: any;
  viewStatusSa?: any;
  viewStatusCn?: any;
  viewStatusRoa?: any;

  iCanMaintenanceMode: boolean = false;
  iCanViewArchive: boolean = false;
  iCanArchive: boolean = false;

  bridge_image?: string = null;

  image?: string = null;

  description?: string = null;

  datasheetUrl?: string = ''; // Database does not allow null for datasheetUrls
  cadfilesUrl?: string = '';
  designguideUrl?: string = '';

  toggleVisibility: boolean = false;
  toggleMaintenanceMode: boolean = false;
  toggleSortOrder: boolean = false;
  toggleImages: boolean = false;
  toggleDescription: boolean = false;

  toggleViewStatus: boolean = false;
  toggleViewStatusNa: boolean = false;
  toggleViewStatusSa: boolean = false;
  toggleViewStatusCn: boolean = false;
  toggleViewStatusRoa: boolean = false;

  toggleDataSheet: boolean = false;
  toggleUrls: boolean = false;

  possibleSensorApplications: any;
  sensorApplications: Array<any> = [];
  toggleSensorApplications: boolean = false;

  applications: Array<any> = [];
  toggleApplications: boolean = false;

  constructor(private admin: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private toast: ToastsManager) {}

  ngOnInit() {

    log.d('ngOnInit');
    // this.path = (this.route.snapshot.parent.params['type'] === 'modules') ? '/drilldown/modules' : '/drilldown/drivers';
    //
    this.route.params.subscribe((params: any) => {
      log.d(`route /${this.route.snapshot.parent.params['type']}/${params['id']}`, );
      this.bridgeIds = params.list.split(',').map( param => parseInt(param) ); // moet een array met getallen worden.
      log.d('bridge received from params', this.bridgeIds);


      this.admin.getBridgeControllers(this.bridgeIds).subscribe((data) => {
        log.d('getBridgeControllers response', data);
        this.bridges = data.data;

        this.admin.getSensorApplications().subscribe((res) => {
          this.possibleSensorApplications = res.data;
        });
      });
    });
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this[input.model] = input.updatedData;
  }

  public onSubmit() {
    for (const bridge of this.bridges) {
      if (this.toggleViewStatus) {
        bridge.viewStatus = this.viewStatus;
      }
      if (this.toggleViewStatusNa) {
        bridge.viewStatusNa = this.viewStatusNa;
      }
      if (this.toggleViewStatusSa) {
        bridge.viewStatusSa = this.viewStatusSa;
      }
      if (this.toggleViewStatusCn) {
        bridge.viewStatusCn = this.viewStatusCn;
      }
      if (this.toggleViewStatusRoa) {
        bridge.viewStatusRoa = this.viewStatusRoa;
      }

      if (this.toggleImages) {
        bridge.image = this.bridge_image;
      }
      if (this.toggleDescription) {
        bridge.description = this.description;
      }
      if (this.toggleDataSheet) {
        bridge.datasheetUrl = this.datasheetUrl;
      }
      if (this.toggleUrls) {
        bridge.cadfilesUrl = this.cadfilesUrl;
      }
      if (this.toggleUrls) {
        bridge.designguideUrl = this.designguideUrl;
      }
      if (this.toggleApplications) {
        bridge.applications = this.applications;
      }
      if (this.toggleSensorApplications) {
        bridge.sensorApplications = this.sensorApplications;
      }
    }

    log.d('updated bridges', this.bridges);

    this.admin.postBridgeControllers(this.bridges).subscribe(data => {
      this.toast.success(`Changes have been saved.`);
      this.router.navigate(['/drilldown/bridges', {refresh: Date.now()}]);
    });
  }

  public onCancel() {
    log.d('onCancel');
    this.router.navigate(['/drilldown/bridges', {refresh: Date.now()}]);
  }
}



// WEBPACK FOOTER //
// ./src/app/batch/bridges/edit.component.ts